<template>
    <Step :activeStep="0" :actions="actions">
        <template v-slot:main>
            <div class="club-step__membership-picker">
                <div class="club-step__membership-list">
                    <div
                        :class="getMembershipClass(tier)"
                        v-for="tier in memberships"
                        v-if="tier.AnnuallyBottles > 0"
                        :key="'tier' + tier.ID"
                        @click="changeMemberTier(tier)"
                    >
                        <div class="club-step__membership-unit">
                            <p class="club-step__membership-amount">
                                {{ tier.AnnuallyBottles / 4 }}
                            </p>
                            <p class="club-step__membership-amount-text">
                                Bottles/
                                <br />quarter
                            </p>
                        </div>
                        <div
                            class="club-step__membership-discount"
                            v-if="tier.Discount && tier.Discount.Percent"
                        >
                            Save {{ `${tier.Discount.Percent * 100}%` }}
                        </div>
                    </div>
                </div>
                <div
                    class="club-step__membership-description"
                    v-if="getMemberTier"
                    v-html="getMemberTier.Description"
                ></div>
            </div>
        </template>
    </Step>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Step from "./layouts/Step.vue";
export default {
    name: "Step1",
    components: {
        Step,
    },
    props: {
        memberships: {
            type: Array,
        },
    },
    data() {
        return {
            actions: [
                {
                    title: "Choose Wine",
                    className: "btn-primary",
                    method: this.chooseWine,
                },
            ],
        }
    },
    mounted() {
        // nextTick because we generate classes with a function.
        this.$nextTick(() => {
            this.setDefaults();
        });
    },
    computed: {
        ...mapGetters(["getMemberTier"]),
    },
    methods: {
        ...mapActions(["changeMemberTier", "setConfigStep"]),
        setDefaults() {
            // If no membership select the second membership by default
            if (
                this.getMemberTier === null ||
                this.getMemberTier === undefined
            ) {
                this.changeMemberTier(this.memberships[1]);
            }
            // console.log(this.getMemberTier)
        },
        chooseWine() {
            this.setConfigStep(1);
        },
        getMembershipClass(tier) {
            const classList = ["club-step__membership"];

            if (this.getMemberTier && this.getMemberTier.ID === tier.ID) {
                classList.push("active");
            }

            return classList.join(" ");
        },
    },
};
</script>
